<!-- eslint-disable -->
<template lang="pug">
    .modal
        .modal__background(:class="{'modal__background--blur': isBlur}", @click="close")
        .modal__container(:class=`{
            'modal__container--huge': areIndividualSettings,
            'modal__container--big': isForMultiplayerSettings
        }`)
            .modal__box(:class="{'modal__box--user': color}")
                span.modal__close-container(@click="close")
                    svg-icon.modal__close(name="circle-close", size="x-large")
                header.modal__header(v-if="$slots['header']")
                    slot(name="header")
                .modal__body
                    slot
                footer.modal__footer(v-if="$slots['footer']")
                    slot(name="footer")
</template>

<script>
    /*eslint-disable*/
    export default {
        name: 'CsModal',
        props: {
            isBlur: {
                Boolean,
                default: false
            },
            color: {
                Boolean,
                default: false
            },
            puzzleImages: {
                type: Boolean,
                default: false,
            },
            isForMultiplayerSettings: {
                type: Boolean,
                default: false,
            },
            areIndividualSettings: {
                type: Boolean,
                default: false,
            }
        },
        status: 'ready',
        release: '1.0.0',
        methods: {
            close () {
                this.$emit('close')
            }
        },
        mounted () {
            document.documentElement.style.setProperty('overflow',"hidden");
            if (this.puzzleImages) {
                let container = document.querySelector('.modal__container');
                if (container) {
                    container.classList.add('modal__container_wide');
                }
            }
        },
        beforeDestroy () {
            document.documentElement.style.setProperty('overflow',"auto");
        }
    }
</script>

<style lang="scss" scoped>
    .modal {
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        position: fixed;
        z-index: $z-index-modal;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .modal__background {
        width: 100vw;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba($x-color-black, $opacity-default-modal-background);
    }

    .modal__background--blur {
        width: 100vw;
        height: 100vh;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba($x-color-black, $opacity-blur-modal-background);
        backdrop-filter: blur($blur-default-modal-background);
    }

    .modal__box {
        background-color: $x-color-white;
        padding: 30px;
        border-radius: $border-radius-20;
        @include media($md) {
            padding: 30px;
        }
    }

    .modal__box--user {
        background-color: var(--user-main-color);
    }

    .modal__box--user > .modal__close-container {
        color: $x-color-white;
    }

    .modal__container {
        position: relative;
        width: 100%;
        max-height: calc(100% - 40px);
        overflow-x: hidden;
        overflow-y: auto;
        box-sizing: border-box;
        max-width: 320px;
        @include media($md) {
            max-width: 600px;
        }
        &_wide {
            @media screen and (max-width: 767px) and (min-width: 575px) {
                max-width: 575px;
            }
        }
        &--big {
            max-width: 800px;
        }
        &--huge {
            max-width: 980px;
        }
    }
    ::-webkit-scrollbar {
        width: 5px;
    }

    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    ::-webkit-scrollbar {
        background-color: #F5F5F5;
        height: 2px;
    }

    ::-webkit-scrollbar-thumb {
        height: 2px;
        background: $color-grey-600;
    }

    .modal__header {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        display: flex;
        justify-content: center;
        text-align: center;
    }

    .modal__body {
        text-align: center;
    }

    .modal__close-container {
        display: inline-flex;
        position: absolute;
        right: 20px;
        top: 20px;
        cursor: pointer;
        color: $hsl-color-green-58;

        &:hover {
            color: $hsl-color-red-62;
        }
    }

    .modal__footer {
        padding: $space-x-small;
    }
</style>
